import React from "react";
import { createContext, useState } from "react";

export const TasksContext = createContext();

const TasksProvider = ({ children }) => {

    const [taskDetails, setTaskDetails] = useState([]);

    return <TasksContext.Provider value={{ taskDetails, setTaskDetails }}>{children}</TasksContext.Provider>
}

export default TasksProvider;